import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionShopCharacteristicsReceived, TypeActionShop } from "../actionShop";
export var epicShopUpdateOfferCharacteristics = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShop.RequestUpdate), switchMap(function () {
        var state = state$.value;
        var playerInfo = selectPlayerInfo(state);
        return deps.netSend({
            id: CommandCode.OfferCharacteristicsList,
            props: {
                playerId: playerInfo.playerId,
            },
        });
    }), retry(), map(function (res) { return actionShopCharacteristicsReceived(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopUpdateOfferCharacteristics.ts
// module id = 2343
// module chunks = 3